import Section from "components/layout/section"
import { useTranslation } from "react-i18next"
import PageTitle from "features/navigation/pageTitle"
import RightSidebar from "@/components/sidebar/right/RightSidebar"

const SUPPORT_EMAIL = "support@ordnat.com"

const SupportPage = () => {
    const { t } = useTranslation()
    const message = t("supportBody", { email: SUPPORT_EMAIL })
    const [before, after = ""] = message.split(SUPPORT_EMAIL)

    return (
        <>
            <PageTitle title={t("titleSupport")} />
            <Section>
                <p>
                    {before}
                    <a className="underline" href={`mailto:${SUPPORT_EMAIL}`}>{SUPPORT_EMAIL}</a>
                    {after}
                </p>
            </Section>
            <RightSidebar />
        </>
    )
}

export default SupportPage
